import { projectSettingsSoftwareIssuetypesWorkflowRoute } from '@jira/router-routes__project-settings-workflow-editor-software-routes/src/projectSettingsSoftwareIssuetypesWorkflowRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { workflowBuilderProvisioningResource } from '@jira/router-resources__admin-pages-workflows-workflow-builder-provisioning/src/useWorkflowBuilderProvisioning.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { LazyIssueTypeSettings } from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/issue-type/index.tsx';
import { getSettingsNavigationResources } from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/product-routes/common/index.tsx';
import WorkflowNavigationPage from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/workflow-navigation/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const projectSettingsSoftwareIssuetypesWorkflowRouteEntry: Route = createEntry(
	projectSettingsSoftwareIssuetypesWorkflowRoute,
	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: WorkflowNavigationPage,

		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...jiraSpaResources(),
			...getSettingsNavigationResources(),
			...getWorkflowBuilderProvisioningResources(),
			workflowBuilderProvisioningResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@jira/router-routes__project-settings-workflow-editor-software-entries/src/projectSettingsSoftwareIssuetypesWorkflowRouteEntry.tsx',
				whichExportToUse: 'projectSettingsSoftwareIssuetypesWorkflowRouteEntry',
			},

			enabled: true,
		},
	}),
);
